import { useTranslation } from 'react-i18next';
import { ArrowRight, ExternalLink, ShoppingBag, Truck, Shield, CreditCard } from 'lucide-react';

export default function CTA() {
  const { t } = useTranslation();

  const benefits = [
    { icon: ShoppingBag, label: '14+ Product Categories', desc: 'Shoes, hoodies, bags, accessories & more' },
    { icon: Truck, label: 'Global Shipping', desc: 'Ships to USA, UK, EU & worldwide' },
    { icon: Shield, label: 'QC Verified', desc: 'Quality checks before every shipment' },
    { icon: CreditCard, label: 'Secure Payment', desc: 'Multiple safe payment options' },
  ];

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Row%20of%20colorful%20shopping%20bags%20in%20coral%20teal%20and%20mustard%20arranged%20on%20a%20light%20wood%20table%2C%20bright%20cheerful%20studio%20lighting%2C%20minimal%20retail%20lifestyle%20photography%2C%20vibrant%20welcoming%20palette%20with%20soft%20shadows&width=1920&height=800&seq=cta-main-bg-402&orientation=landscape&nocache=true"
          alt="AllChinaBuy Spreadsheet Products"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-foreground-950/60 to-foreground-950/70" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 xl:px-12 py-16 md:py-24">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 mb-6 text-xs font-semibold tracking-widest uppercase text-background-100 bg-background-950/30 backdrop-blur-sm rounded-full border border-background-100/20">
            Get Started
          </span>

          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-5 leading-tight">
            {t('cta.title')}
          </h2>

          <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            {t('cta.description')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-12">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-7 md:px-9 py-3.5 md:py-4 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-xl transition-all duration-300 whitespace-nowrap"
            >
              <ShoppingBag className="w-5 h-5" />
              {t('cta.mainSite')}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-7 md:px-9 py-3.5 md:py-4 bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-background-50 font-semibold rounded-xl border border-background-100/30 transition-all duration-300 whitespace-nowrap"
            >
              {t('cta.buyNow')}
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center p-4 md:p-5 rounded-xl bg-background-50/10 backdrop-blur-sm border border-background-100/15"
              >
                <benefit.icon className="w-6 h-6 md:w-7 md:h-7 text-background-100 mb-2" />
                <span className="text-sm font-semibold text-background-50 mb-0.5">{benefit.label}</span>
                <span className="text-xs text-background-100/70">{benefit.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}